import i18n from '@/i18n'
export default {
    fields: [
        {
            key: '_select',
            label: 'Select',
            class: 'text-center align-middle',
            colGroup: i18n.t('people.select'),
            title: i18n.t('people.select'),
            modules: [],
            roles: [],
            thClass: '',
            tdClass: '',
            order: -1,
        },
        {
            key: 'picture',
            label: i18n.t('people.picture'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.user'),
            title: i18n.t('people.user'),
            modules: [],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'user-info',
            order: 1,
        },
        {
            key: 'name',
            label: i18n.t('people.name'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.user'),
            title: i18n.t('people.user'),
            modules: [],
            roles: [],
            thClass: '',
            tdClass: '',
            order: 2,
        },
        {
            key: 'status',
            label: i18n.t('people.status'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.user'),
            title: i18n.t('people.status'),
            modules: [],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'user-info',
            order: 3,
        },
        {
            key: 'unit_goals_achieved',
            label: i18n.t('people.organization'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.performance'),
            title: i18n.t('people.goalsPerformance'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-performance',
            order: 4,
        },
        {
            key: 'department_goals_achieved',
            label: i18n.t('people.team'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.performance'),
            title: i18n.t('people.goalsPerformance'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-performance',
            order: 5,
        },
        {
            key: 'personal_goals_achieved',
            label: i18n.t('people.individual'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.performance'),
            title: i18n.t('people.goalsPerformance'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-performance',
            order: 6,
        },
        {
            key: 'unit_goals_amount',
            label: i18n.t('people.organization'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.amount'),
            title: i18n.t('people.amountOfGoals'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-count',
            order: 8,
        },
        {
            key: 'department_goals_amount',
            label: i18n.t('people.team'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.amount'),
            title: i18n.t('people.amountOfGoals'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-count',
            order: 9,
        },
        {
            key: 'personal_goals_amount',
            label: i18n.t('people.individual'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.amount'),
            title: i18n.t('people.amountOfGoals'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-count',
            order: 10,
        },
        {
            key: 'unit_goals_weight',
            label: i18n.t('people.organization'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.weight'),
            title: i18n.t('people.goalsWeight'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-weight',
            order: 12,
        },
        {
            key: 'department_goals_weight',
            label: i18n.t('people.team'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.weight'),
            title: i18n.t('people.goalsWeight'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-weight',
            order: 13,
        },
        {
            key: 'personal_goals_weight',
            label: i18n.t('people.individual'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.weight'),
            title: i18n.t('people.goalsWeight'),
            modules: ['has_goal', 'has_kpi'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-weight',
            order: 14,
        },
        {
            key: 'owner_evaluation',
            label: i18n.t('profile.targetsTable.selfEvaluate'),
            class: 'text-center align-middle',
            colGroup: i18n.t('profile.targetsTable.evaluations'),
            title: i18n.t('profile.targetsTable.selfEvaluate'),
            modules: ['has_goal'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-evaluation',
            order: 16,
        },
        {
            key: 'manager_evaluation',
            label: i18n.t('profile.targetsTable.managerEvaluate'),
            class: 'text-center align-middle',
            colGroup: i18n.t('profile.targetsTable.evaluations'),
            title: i18n.t('profile.targetsTable.managerEvaluate'),
            modules: ['has_goal'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-evaluation',
            order: 17,
        },
        {
            key: 'committee_evaluation',
            label: i18n.t('profile.targetsTable.committeeEvaluation'),
            class: 'text-center align-middle',
            colGroup: i18n.t('profile.targetsTable.evaluations'),
            title: i18n.t('profile.targetsTable.committeeEvaluation'),
            modules: ['has_goal'],
            roles: [],
            thClass: '',
            tdClass: '',
            routeGroup: 'target-evaluation',
            order: 18,
        },
        {
            key: 'current_stage',
            label: i18n.t('people.title'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.currentStage'),
            title: i18n.t('people.currentStage'),
            modules: ['has_goal', 'has_value'],
            roles: [
                'local_administrator',
                'administrator',
                'god',
                'is_manager',
                'is_values_master',
                'is_target_master',
            ],
            thClass: 'd-none',
            tdClass: 'd-none',
            routeGroup: 'user-stage',
            order: 19,
        },
        {
            key: 'ok_user',
            label: i18n.t('people.user'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.isUserReadyToNextStage'),
            title: i18n.t('people.isUserReadyToNextStage'),
            modules: ['has_value', 'has_goal'],
            roles: [
                'local_administrator',
                'administrator',
                'god',
                'is_manager',
                'is_values_master',
                'is_target_master',
            ],
            thClass: 'd-none',
            tdClass: 'd-none',
            routeGroup: 'user-next-stage-info',
            order: 20,
        },
        {
            key: 'ok_manager',
            label: i18n.t('people.manager'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.isUserReadyToNextStage'),
            title: i18n.t('people.isUserReadyToNextStage'),
            modules: ['has_value', 'has_goal'],
            roles: [
                'local_administrator',
                'administrator',
                'god',
                'is_manager',
                'is_values_master',
                'is_target_master',
            ],
            thClass: 'd-none',
            tdClass: 'd-none',
            routeGroup: 'user-next-stage-info',
            order: 21,
        },
        {
            key: 'network',
            label: i18n.t('values.networks'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.values'),
            title: i18n.t('people.values'),
            modules: ['has_value'],
            roles: ['local_administrator', 'administrator', 'god', 'is_manager', 'is_values_master'],
            thClass: 'd-none',
            tdClass: 'd-none',
            order: 22,
        },
        {
            key: 'released_networks',
            label: i18n.t('people.networks'),
            class: 'text-center align-middle',
            colGroup: i18n.t('people.values'),
            title: i18n.t('people.values'),
            modules: ['has_value'],
            roles: ['local_administrator', 'administrator', 'god', 'is_values_master'],
            thClass: 'd-none',
            tdClass: 'd-none',
            routeGroup: 'user-networks',
            order: 23,
        },
    ],
    columnsAllowedToSortedBy: ['name', 'status', 'current_stage'],
    perPageOptions: ['5', '10', '20', '30', '50', '100', '300', '500'],
}
